import { Modal } from 'antd'

export const useFeaturesInProgress = () => {
  const [modal, contextHolder] = Modal.useModal()

  return {
    show() {
      modal.info({ title: '功能正在开发中,敬请期待...', maskClosable: true })
    },
    contextHolder,
  }
}
